import { render } from "./detailsItensComponent.vue?vue&type=template&id=2fc36fa9"
import script from "./detailsItensComponent.vue?vue&type=script&lang=js"
export * from "./detailsItensComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__